function openNav() {
    document.getElementById("mySidenav").style.left = "0";
    $("body").addClass("body-overlay myclass");  // Add 'myclass' when sidenav opens
    $("#single_product_content, #products_collections, #your_look, #customer_reviews, #shirts_collection").css("z-index", "-1");
}

function closeNav() {
    document.getElementById("mySidenav").style.left = "-100%";
    $("body").removeClass("body-overlay myclass");  // Remove 'myclass' when sidenav closes
    $("#single_product_content, #products_collections, #your_look, #customer_reviews, #shirts_collection").css("z-index", "1");
}

function handlesidenavPos(t) {
    if (t.clientX >= 300) {
        document.getElementById("mySidenav").style.left = "-100%";
        $("body").removeClass("body-overlay myclass");  // Remove 'myclass' when side nav is closed by mouse move
        $("#single_product_content").css("z-index", "1");
    }
}

function openCart() {
    (document.getElementById("cartDrawer").style.right = "0"), $("body").addClass("back-overlay"), $("#transcyBtnSwitcher").hide();
}
function closeCart() {
    (document.getElementById("cartDrawer").style.right = "-100%"), $("body").removeClass("back-overlay"), $("#transcyBtnSwitcher").show();
}
AOS.init(),
    document.addEventListener("click", handlesidenavPos),
    jQuery("li.dropdown .nav-item").click(function () {
        $(this).parents("li.dropdown .nav-item").toggleClass("current"), jQuery(this).parents("li.dropdown").find("ul.dropdown-menu").toggleClass("submenu-active"), jQuery("#mySidenav").scrollTop(0);
    }),
    jQuery("li.dropdown ul.dropdown-menu span.back-menu").click(function () {
        jQuery(this).parents("ul.dropdown-menu").removeClass("submenu-active"), $("li.dropdown .nav-item").removeClass("current");
    });
var swiper = new Swiper(".swiper_collections_slider", {
    pagination: ".swiper-pagination",
    slidesPerView: "5",
    paginationClickable: !0,
    spaceBetween: 20,
    freeMode: !1,
    slideToClickedSlide: !0,
    loop: !0,
    nextButton: ".swiper-button-next",
    prevButton: ".swiper-button-prev",
    navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
    breakpoints: { 640: { freemode: !1, slidesPerView: 1, spaceBetween: 0 }, 320: { freemode: !1, slidesPerView: 1, spaceBetween: 0 } },
});
(swiper = new Swiper(" .swiper_collections-sports ", {
    pagination: ".swiper-pagination",
    slidesPerView: "4",
    paginationClickable: !0,
    spaceBetween: 20,
    freeMode: !1,
    slideToClickedSlide: !0,
    loop: !0,
    nextButton: ".swiper-button-next",
    prevButton: ".swiper-button-prev",
    navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
    breakpoints: { 640: { freemode: !1, slidesPerView: 1, spaceBetween: 0 }, 320: { freemode: !1, slidesPerView: 1, spaceBetween: 0 } },
})),
    (swiper = new Swiper(".swiper_grid", {
        pagination: ".swiper-pagination",
        slidesPerView: "4",
        paginationClickable: !0,
        spaceBetween: 0,
        slideToClickedSlide: !0,
        loop: !0,
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        breakpoints: { 320: { slidesPerView: 1, spaceBetween: 0 }, 640: { slidesPerView: 1, spaceBetween: 0 } },
    }));
function incrementValue(t) {
    t.preventDefault();
    var e = $(t.target).data("field"),
        n = $(t.target).closest("div"),
        a = parseInt(n.find("input[name=" + e + "]").val(), 10);
    n.find("input[name=" + e + "]")
        .val(a + 1)
        .trigger("change");
}
function decrementValue(t) {
    t.preventDefault();
    var e = $(t.target).data("field"),
        n = $(t.target).closest("div"),
        a = parseInt(n.find("input[name=" + e + "]").val(), 10);
    a > 1 &&
        n
            .find("input[name=" + e + "]")
            .val(a - 1)
            .trigger("change");
}
function _generateToken() {
    for (var t = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split(""), e = [], n = 0; n < 10; n++) {
        var a = (Math.random() * (t.length - 1)).toFixed(0);
        e[n] = t[a];
    }
    return e.join("");
}
$(document).on("click", ".input-group .button-plus", function (t) {
    incrementValue(t);
}),
    $(document).on("click", ".input-group .button-minus", function (t) {
        decrementValue(t);
    }),
    $(document).ready(function () {
        $(window).width() > 767 && $(".easy-zoom").zoom();
    }),
    $(document).ready(function () {
        var t = "true";
        $(".action-form")
            .find("form .option_selection")
            .each(function () {
                "" == $(this).find("select").val() && (t = "false");
            }),
            "true" == t ? $(".single-add-to-cart-button").addClass("active-atc") : $(".single-add-to-cart-button").removeClass("active-atc");
    }),
    $(document).on("change", ".option_selection select", function () {
        var t = !1,
            e = [],
            n = "true";
        $(this)
            .parents(".action-form")
            .find("form .option_selection")
            .each(function () {
                var t = $(this).find("select").val();
                "" == t && (n = "false"), "" != t && e.push(t);
            });
        var a = e.join(" / ");
        $(".product-js")
            .find("option")
            .each(function () {
                var e = $(this).val(),
                    i = $(this).attr("data-id"),
                    o = $(this).attr("price"),
                    r = $(this).attr("data-qty"),
                    s = $(this).attr("var-sku"),
                    d = $(this).attr("compare-at-price");
                if (a == e) {
                    if (((t = !0), $("#add_item_id_pp").val(i), $(".product-details-group .price del").text(d), $(".product-details-group .price ins").text(o), $(".product-meta-group .sku_wrapper .sku").text(s), r < 1)) {
                        var c = $(this).parents("form").find(".my-custom-class");
                        $(this).parents("form").find(".single-add-to-cart-button").attr("disabled", "true"), c.removeClass("my-custom-class"), (n = "false");
                    }
                    if (r > 0) (c = $(this).parents("form").find(".pixii")).addClass("my-custom-class"), $(this).parents("form").find(".single-add-to-cart-button").removeAttr("disabled"), $(this).css("background", "#7f7f7f"), (n = "true");
                }
            }),
            0 == t && "true" == n ? ($(".user_message").show(), $(".pixii").addClass("my-custom-class"), $(".single-add-to-cart-button").attr("disabled", "true"), (n = "false")) : $(".user_message").hide(),
            "true" == n ? $(".single-add-to-cart-button").addClass("active-atc") : $(".single-add-to-cart-button").removeClass("active-atc");
    });
var G_token = _generateToken();
$(document).on("click", ".single-add-to-cart-button", function (t) {
    t.preventDefault();
    var e = !0;
    if (
        ($(".option_selection").each(function () {
            var t = $(this).find("select").val(),
                n = $(this).find("label").text();
            "" == t && ((e = !1), alert("Please Select " + n + " Option"));
        }),
        e)
    ) {
        var n = $("#add_item_id_pp").val(),
            a = $("#qty_box_pp #quantity").val(),
            i = $(this).attr("collection-name"),
            o = $("#shirts-addonItem").val();
        if ("camicie" == i && "" != o) {
            var r = $("#shirts-addonItem").attr("addon-data-id"),
                s = _generateToken();
            Data = {
                items: [
                    {
                        quantity: a,
                        id: n,
                        properties: {
                            "Add your initials (optional)": o,
                            Color: $("#additional-color").val(),
                            Position: $("#additional-position").val(),
                            Character: $("#additional-character").val(),
                            _Gtoken: n + ":" + s,
                            _additional_product_ids: r,
                        },
                    },
                    { quantity: a, id: r, properties: { _Gtoken: n + ":" + s, _cart_status: "hidden" } },
                ],
            };
        } else Data = { quantity: a, id: n };
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data: Data,
            success: function () {
                $.ajax({
                    type: "GET",
                    url: "/cart.js",
                    dataType: "json",
                    success: function (t) {
                        var e = t.item_count;
                        $.each(t.items, function (t, n) {
                            46723788210501 == n.id && (e = parseInt(e) - parseInt(n.quantity));
                        }),
                            $("header .shop-cart-count").text(e);
                    },
                    error: function (t) {
                        console.log(t);
                    },
                }),
                    $.ajax({
                        type: "GET",
                        url: "/cart?view=cart-drawer-new",
                        beforeSend: function () {
                            $("#cartDrawer .loading-overlay").removeClass("hidden");
                        },
                        complete: function () {
                            $("#cartDrawer .loading-overlay").addClass("hidden");
                        },
                        success: function (t) {
                            var e = $(t).find("#cart-drawer-items").html();
                            $("#cart-drawer-items").html(e);
                        },
                        error: function (t) {
                            console.log(t);
                        },
                    }),
                    openCart();
            },
            error: function (t) {
                console.log(t);
            },
        });
    }
}),
    $(document).on("click", ".RemoveItem_cart", function (t) {
        t.preventDefault();
        var e = {},
            n = {},
            a = $(this).parents(".cart-tab-col").attr("data-variant-id"),
            i = $(this).parents(".cart-tab-col").attr("additional-item-id");
        (e[a] = 0),
            $.fn.updatecart(e),
            "" != i &&
                setTimeout(function () {
                    (n[i] = 0), $.fn.updatecart(n);
                }, 200);
    }),
    ($.fn.updatecart = function (t) {
        $.ajax({
            type: "POST",
            url: "/cart/update.js",
            data: { updates: t },
            dataType: "json",
            success: function (t) {
                var e = t.item_count;
                $.each(t.items, function (t, n) {
                    46723788210501 == n.id && (e = parseInt(e) - parseInt(n.quantity));
                }),
                    $("header .shop-cart-count").text(e),
                    $.ajax({
                        type: "GET",
                        url: "/cart?view=cart-drawer-new",
                        beforeSend: function () {
                            $("#cartDrawer .loading-overlay").removeClass("hidden");
                        },
                        complete: function () {
                            $("#cartDrawer .loading-overlay").addClass("hidden");
                        },
                        success: function (t) {
                            var e = $(t).find("#cart-drawer-items").html();
                            $("#cart-drawer-items").html(e);
                        },
                        error: function (t) {
                            console.log(t);
                        },
                    });
            },
        });
    }),
    $(document).on("change", ".mini-cart-product-infor #quantity", function (t) {
        t.preventDefault();
        var e = {},
            n = {},
            a = $(this).parents(".cart-tab-col").attr("data-variant-id"),
            i = $(this).parents(".cart-tab-col").attr("additional-item-id"),
            o = $(this).val();
        (e[a] = parseInt(o)),
            $.fn.updatecart(e),
            "" != i &&
                setTimeout(function () {
                    (n[i] = parseInt(o)), $.fn.updatecart(n);
                }, 200);
    }),
    $(document).on("keyup", "#shirts-addonItem", function () {
        "" == $(this).val() ? $(".additional-dropdowns").hide() : $(".additional-dropdowns").show();
    }),
    $("#transcyBtnSwitcher").hover(function () {
        $(this).siblings(".transcy-switcher.transcy-dropdown-language").addClass("transcy-show");
    }),
    $(document).on("click", ".modal-size .nav-tabs .nav-link", function () {
        $(".modal-size .nav-tabs .nav-link").not(this).removeClass("active"), $(this).addClass("active");
        var t = $(this).data("m1-size"),
            e = $(this).data("m2-size"),
            n = $(this).data("m3-size");
        "" != t && $(".size_m1").text(t), "" != e && $(".size_m2").text(e), "" != n && $(".size_m3").text(n);
    }),
    $(document).on("click", ".gift_values_item_label", function () {
        var t = $(this).siblings(".gift_values_item_input").val();
        $(".product-js")
            .find("option")
            .each(function () {
                var e = $(this).val(),
                    n = $(this).attr("data-id");
                t == e && $("#add_item_id_pp").val(n);
            });
    }),
    $(document).on("mouseenter", ".man_menu", function () {
        $(".menu_top").not(this).removeClass("active_item"), $(this).addClass("active_item"), $(".mans_ul").show(), $(".womens_ul").hide();
    }),
    $(document).on("mouseenter", ".women_menu", function () {
        $(".menu_top").not(this).removeClass("active_item"), $(this).addClass("active_item"), $(".mans_ul").hide(), $(".womens_ul").show();
    });
